import { swymFetch } from '~/services/fetch-swym'

import { getIdeaStatuses } from '~/entities/container/community/api/communities'
import type { RelatedLink, RelatedLinkBE } from '~/entities/content/idea/api/parser-idea-related-link'
import { parseIdeaRelatedLinkResponse, parseIdeaRelatedLinksResponse } from '~/entities/content/idea/api/parser-idea-related-link'
import type { IIdea } from '~/entities/content/idea/interfaces/idea'
import type { EnoviaObjectType, FormerEnoviaObjectType } from '~/entities/content/idea/interfaces/space-ideas'

import { contentParser } from '~/features-shared/content/api/parser-contents'
import type { IContent } from '~/features-shared/content/interfaces/content'
import type { ISwymContent } from '~/features-shared/content/interfaces/swym-content'

import type { SwymService } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

type getStatusesReturn = Record<string, { position: number, color: string }>
type SwymIdeaService = SwymService<IIdea> & {
  getStatuses: (params: { communityUri: string, derivedTypeId?: string }) => Promise<getStatusesReturn>
}

export const IdeasService: SwymIdeaService = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll() {
    throw new Error('Function not implemented.')
  },
  // TODO: Refractor this
  async getStatuses(params) {
    const response = await getIdeaStatuses(params.communityUri, params.derivedTypeId)
    const { result } = response

    const extractedMaturities: Record<string, { position: number, color: string }> = result
      .map(c => ({ id: c.title, position: c.position, color: c.color }))
      .reduce((pre, cur) => ({ ...pre, ...{ [cur.id]: { position: cur.position, color: cur.color } } }), {})

    return extractedMaturities
  },
}

export function getIdeaRelatedLinks(uri: string): Promise<SwymResponse<RelatedLink[]>> {
  return swymFetch
    .post('/api/IdeationLink/list', {
      json: {
        params: {
          ideation_id: uri,
        },
      },
    })
    .json<SwymResponse<RelatedLinkBE[]>>()
    .then(response => parseIdeaRelatedLinksResponse(response, uri))
}

interface RelatedLinkOptions {
  type: 'internal' | 'external_url' | EnoviaObjectType | FormerEnoviaObjectType
  model_id?: string
  model?: string
  ideation_id: string
  url?: string
  title?: string
  content_key?: string
}

export function createIdeaRelatedLink(options: RelatedLinkOptions) {
  return swymFetch
    .post('/api/IdeationLink/add', {
      json: {
        params: {
          type: options.type,
          model_id: options.model_id,
          model: options.model,
          ideation_id: options.ideation_id,
          url: options.url,
          title: options.title,
          content_key: options.content_key,
        },
      },
    })
    .json<SwymResponse<RelatedLinkBE>>()
    .then(response => parseIdeaRelatedLinkResponse(response, options.ideation_id))
}

export function deleteIdeaRelatedLink(id: string): Promise<SwymResponse<''>> {
  return swymFetch
    .post('/api/IdeationLink/delete', {
      json: { params: { ideation_link_id: id } },
    })
    .json()
}

export interface UpdateIdeaStatusOptions {
  idea_id: string
  out?: boolean
  status_id: string
  status_comment: string
}

export function updateIdeaStatus(options: UpdateIdeaStatusOptions): Promise<SwymResponse<IContent>> {
  return swymFetch
    .post('/api/Ideation/updateideationstatus', {
      json: {
        params: {
          id: options.idea_id,
          status_id: options.status_id,
          out: !!options.out,
          status_comment: options.status_comment,
        },
      },
    })
    .json<SwymResponse<ISwymContent>>()
    .then(contentParser)
}
